module.exports = __webpack_public_path__ + "img/pp3.77e0ef4a.jpeg";